import styled from 'styled-components';

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var _templateObject;

var Image = styled.img(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: block;\n  max-width: 100%;\n  height: auto;\n"])));
Image.displayName = 'Image';
export { Image };